export default __webpack_public_path__ + "static/scARf1-9be96a6adc41222f564530730a8985c5.jpeg";